import axios from "axios";
import moment from "moment";

export default {
  new() {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/`
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  get(uuid) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/${uuid}`
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response));
    });
  },
  save(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "patch",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/${data.uuid}`,
        data: data
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  saveProspect(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "put",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/${data.uuid}/prospect`,
        data: data
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getMail(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/comparator/${data.uuid}/mail`,
        params: {
          view: data.view,
          lang: data.lang
        }
      })
          .then(response => resolve(response.data))
          .catch(error => reject(error));
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/leadService.js